import styled, {css} from 'styled-components'
import Div from 'shared/Div'

export default styled(Div)`
  display: flex;
  flex-flow: row nowrap;

  ${props => props.column && css`
    flex-direction: column;
  `}

  ${props => props.wrap && css`
    flex-wrap: wrap;
  `}

  ${props => props.alignItems && css`
    align-items: ${props.alignItems};
  `}

  ${props => props.justifyContent && css`
    justify-content: ${props.justifyContent};
  `}

  ${props => props.center && css`
    justify-content: center;
    align-items: center;
  `}

  ${props => props.gutter && css`
    margin: calc(-${props => props.theme.gutter}/2);
  `}

  > * {
    flex: 0 1 auto;

    ${props => props.gutter && css`
      margin: calc(${props => props.theme.gutter}/2);
    `}
  }

  ${props => props.mobile && css`
    @media (max-width: ${props.theme.small}) {
      ${props.mobile}
    }
  `}

  ${props => props.animate && css`
    // transform: skewX(-20deg);
    // transform-origin: bottom left;
    // transition: all .5s;

    // :hover {
    //   transform: skewX(-10deg);
    //   max-height: 150px;
    //   transition: all .5s;
    // }
  `}

  ${props => props.extraStyles && css`
    ${props.extraStyles}
  `}

`

// alignItems and justifyContent attrs expect values
// wrap, column, center attrs don't expect values
// center is shorthand



// WEBPACK FOOTER //
// ./src/shared/Flex.js